<div class="row row1">
  <div class="col-sm-12 header-container">
    <h2>History</h2>
  </div>
</div>
<div class="panel panel-card">
  <div class="panel-heading">
    <div class="card-header bp-card-header">
      <i class="fas fa-folder-open payment-options-icon" style="float: left;"></i>
      <p class="font-weight-light bp-text">Billing &amp; Payment History</p>
    </div>
    <div class="clearfix"></div>
  </div>
  <div class="panel-body">
    <p class="looking info">
      Are you looking for a 24 month activity statement? You can download it
      <a href="">here</a>.
      If you need further assistance, please <a  href="#">Contact Us.</a>
    </p>

    <form class="form-inline form-history-actions ng-pristine ng-valid ng-valid-required ng-valid-date ng-valid-min ng-valid-max" novalidate="">
      <div class="row">
        <div class="col-sm-8 margin-bottom-md">
          <div class="form-group date-range-filter">
            <label><span class="hidden-sm">View f</span><span class="visible-sm-inline">F</span>rom</label>
            <br class="visible-xs-block">
            <div class="input-group">
              <input type="text" id="FromDate" name="FromDate" class="form-control"  style="z-index:0  !important;" data-placement="auto bottom" required="" aria-invalid="false">
              <span class="input-group-btn">
                <label class="btn btn-default" for="FromDate" style="z-index:0  !important;">
                  <i class="fa fa-calendar" style="z-index:0  !important;"></i>
                </label>
              </span>
            </div>
            <label>to</label>
            <div class="input-group">
              <input type="text" id="ToDate" name="ToDate" class="form-control" style="z-index:0  !important;" data-placement="auto bottom" required="" aria-invalid="false">
              <span class="input-group-btn">
                <label class="btn btn-default" for="ToDate">
                  <i class="fa fa-calendar"></i>
                </label>
              </span>
            </div>
          </div>
          <button type="submit" class="btn btn-primary">View</button>
        </div>
        <div class="col-sm-4 text-right margin-bottom-md hidden-xs">
          <button type="button" class="btn btn-link">Print</button>
          <button type="button" class="btn btn-link visible-lg-inline-block" lazy-load="true" filename="History.csv" csv-header="billHistory.exportHeader" csv-column-order="billHistory.exportCols" ng-click="billHistory.pushToDataLayer('export')">
            Export
          </button>
        </div>
      </div>
    </form>
    <div>
      <dx-data-grid id="historyGridContainer"
                    [dataSource]="billPayHistory"
                    [masterDetail]="{ enabled: true, template: 'detail' }"
                    [rowAlternationEnabled]="true"
                    keyExpr="ID"
                    [showBorders]="true">

        <dxi-column dataField="BillDate" [width]="125" caption="Date" cssClass="dateLink"></dxi-column>
        <dxi-column dataField="Description" cssClass="dgHeader"></dxi-column>
        <dxi-column dataField="Usage" cssClass="dgHeader"></dxi-column>
        <dxi-column dataField="Amount" cssClass="dgHeader" [width]="170"></dxi-column>

        <div *dxTemplate="let employee of 'detail'">
          <dx-data-grid [dataSource]="employee.data.Detail"
                        [showBorders]="true"
                        [columnAutoWidth]="true">
            <dxi-column dataField="PaymentMethod"></dxi-column>
            <dxi-column dataField="BillingPeriod"></dxi-column>
            <dxi-column dataField="DueDate"></dxi-column>
            <dxi-column dataField="AvgDailyUse"></dxi-column>
            <dxi-column dataField="AvgDailyCost"></dxi-column>
          </dx-data-grid>
        </div>
      </dx-data-grid>
    </div>
</div>
</div>


<div class="panel panel-card">
  <div class="panel-heading">
    <div class="panel-heading">
      <div class="card-header bp-card-header">
        <i class="fas fa-tachometer-alt payment-options-icon" style="float: left;"></i>
        <p class="font-weight-light bp-text">Recent Bill History</p>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="panel-body ">
      <dx-chart id="historyGridChart"
                [dataSource]="chartdDataSource">
        <dxi-series argumentField="month"
                    valueField="usage"
                    name="gal"
                    type="bar"
                    color="#8dda6e">
        </dxi-series>
        <dxo-tooltip [enabled]="true"
                     [customizeTooltip]="customizeTooltip">
        </dxo-tooltip>
      </dx-chart>
    </div>
  </div>
</div>

<div class="panel panel-card" ng-show="billHistory.topicLoaded" aria-hidden="false" style="">
  <div class="panel-heading">
    <div class="card-header bp-card-header">
      <i class="fas fa-question-circle payment-options-icon" style="float: left;"></i>
      <p class="font-weight-light bp-text">Find Answers About History</p>
    </div>
    <div class="clearfix"></div>
  </div>
  <div>
    <ul class="faqUL">
      <li>
        What can I do if I can’t make a payment on time? Can I make a payment arrangement?
      </li>
      <li>
          What payment options are available?
      </li> 
      <li>
         How can I get a copy of my bill?
      </li>
      <li>
        How can I view my account balance?
      </li>
      <li>
        Where do I find my account number and Web Access Code?
      </li>
      <li>
        Show More FAQs
      </li>
    </ul>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/history-container/history-container.component.html